import { Link } from "react-router-dom";

export default function SettingsPayment() {
    return (
        <>
            {/* Content */}
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row g-6">

                    <div className="col-12 col-lg-12 pt-lg-0">
                        <div className="tab-content p-0">

                            <div className="tab-pane fade show active" id="payments" role="tabpanel">
                                <div className="card mb-6">
                                    <div className="card-header">
                                        <h5 className="card-title m-0">Payment providers</h5>
                                    </div>
                                    <div className="card-body">
                                        <p className="mb-5">
                                            Providers that enable you to accept payment methods at a rate set by the third-party.<br />
                                            An additional fee will apply to new orders once you select a plan
                                        </p>
                                        <button
                                            className="btn btn-outline-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#paymentProvider">
                                            Choose a provider
                                        </button>
                                    </div>
                                </div>
                                <div className="card mb-6">
                                    <div className="card-header">
                                        <div className="card-title m-0">
                                            <h5 className="m-0">Supported payment methods</h5>
                                            <p className="card-subtitle mt-0 mb-0">
                                                Payment methods that are available with one of Vuexy's approved payment providers.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h6 className="mb-5">Default</h6>
                                        <div className="bg-lightest p-5 rounded-4 mb-5">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <img
                                                    src="../../assets/img/icons/payments/paypal.png"
                                                    alt="Paypal"
                                                    width="57"
                                                    height="37" />
                                                <span className="fw-medium"><Link to="#">Activate Paypal</Link></span>
                                            </div>
                                            <hr className="my-6 px-1" />
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="text-left w-25">
                                                    <p className="mb-2 small">Provider</p>
                                                    <h6 className="mb-0">Paypal</h6>
                                                </div>
                                                <div className="text-left w-25">
                                                    <p className="mb-2 small">Status</p>
                                                    <small className="badge bg-label-warning rounded-pill fw-normal">Inactive</small>
                                                </div>
                                                <div className="text-left w-25">
                                                    <p className="mb-2 small">Transaction Fee</p>
                                                    <h6 className="mb-0">2.99%</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            className="btn btn-outline-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#paymentMethods">
                                            Add payment methods
                                        </button>
                                    </div>
                                </div>
                                <div className="card mb-6">
                                    <div className="card-header">
                                        <h5 className="card-title m-0">Manual payment methods</h5>
                                    </div>
                                    <div className="card-body">
                                        <p className="mb-5">
                                            Payments that are made outside your online store. When a customer selects a manual payment
                                            method such as cash on delivery. You'll need to approve their order before it can be
                                            fulfilled.
                                        </p>
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-outline-primary">Add manual payment method</button>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary dropdown-toggle dropdown-toggle-split"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false">
                                                <span className="visually-hidden">Toggle Dropdown</span>
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link className="dropdown-item" to="#">Create custom payment method</Link>
                                                </li>
                                                <li><Link className="dropdown-item" to="#">Bank deposit</Link></li>
                                                <li><Link className="dropdown-item" to="#">Money order</Link></li>
                                                <li><Link className="dropdown-item" to="#">Cash on delivery (COD)</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end gap-4">
                                    <button type="reset" className="btn btn-outline-secondary">Discard</button>
                                    <Link className="btn btn-primary" to="#">Save Changes</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Payment provider modal */}
                <div className="modal fade" id="paymentProvider" tabindex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-simple modal-enable-otp modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body p-0">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                <div className="text-center mb-6">
                                    <h4 className="mb-2">Select payment providers</h4>
                                    <p>Third-party payment providers</p>
                                </div>

                                <div
                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between border-bottom py-4 mb-4">
                                    <h6 className="m-0 mb-2 mb-sm-0 me-12">Adyen</h6>
                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/visa-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="visa-card"
                                            data-app-light-img="icons/payments/visa-light.png"
                                            data-app-dark-img="icons/payments/visa-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/master-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="master-card"
                                            data-app-light-img="icons/payments/master-light.png"
                                            data-app-dark-img="icons/payments/master-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/dc-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="diners-club-card"
                                            data-app-light-img="icons/payments/dc-light.png"
                                            data-app-dark-img="icons/payments/dc-dark.png" />
                                    </div>
                                </div>
                                <div
                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between border-bottom pb-4 mb-4">
                                    <h6 className="m-0 mb-2 mb-sm-0">2Checkout</h6>
                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/visa-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="visa-card"
                                            data-app-light-img="icons/payments/visa-light.png"
                                            data-app-dark-img="icons/payments/visa-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/dc-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="diners-club-card"
                                            data-app-light-img="icons/payments/dc-light.png"
                                            data-app-dark-img="icons/payments/dc-dark.png" />
                                    </div>
                                </div>
                                <div
                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between border-bottom pb-4 mb-4">
                                    <h6 className="m-0 mb-2 mb-sm-0">Airpay</h6>
                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/visa-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="visa-card"
                                            data-app-light-img="icons/payments/visa-light.png"
                                            data-app-dark-img="icons/payments/visa-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/master-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="master-card"
                                            data-app-light-img="icons/payments/master-light.png"
                                            data-app-dark-img="icons/payments/master-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                    </div>
                                </div>
                                <div
                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between border-bottom pb-4 mb-4">
                                    <h6 className="m-0 mb-2 mb-sm-0">Authorize.net</h6>

                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/dc-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="diners-club-card"
                                            data-app-light-img="icons/payments/dc-light.png"
                                            data-app-dark-img="icons/payments/dc-dark.png" />
                                    </div>
                                </div>
                                <div
                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between border-bottom pb-4 mb-4">
                                    <h6 className="m-0 mb-2 mb-sm-0">Bambora</h6>

                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/master-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="master-card"
                                            data-app-light-img="icons/payments/master-light.png"
                                            data-app-dark-img="icons/payments/master-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                    </div>
                                </div>
                                <div
                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between border-bottom pb-4 mb-4">
                                    <h6 className="m-0 mb-2 mb-sm-0">Cayan</h6>

                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/visa-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="visa-card"
                                            data-app-light-img="icons/payments/visa-light.png"
                                            data-app-dark-img="icons/payments/visa-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/master-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="master-card"
                                            data-app-light-img="icons/payments/master-light.png"
                                            data-app-dark-img="icons/payments/master-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/dc-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="diners-club-card"
                                            data-app-light-img="icons/payments/dc-light.png"
                                            data-app-dark-img="icons/payments/dc-dark.png" />
                                    </div>
                                </div>
                                <div
                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between border-bottom pb-4 mb-4">
                                    <h6 className="m-0 mb-2 mb-sm-0">Chase Paymentech (Orbital)</h6>

                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/visa-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="visa-card"
                                            data-app-light-img="icons/payments/visa-light.png"
                                            data-app-dark-img="icons/payments/visa-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/dc-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="diners-club-card"
                                            data-app-light-img="icons/payments/dc-light.png"
                                            data-app-dark-img="icons/payments/dc-dark.png" />
                                    </div>
                                </div>
                                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between">
                                    <h6 className="m-0 mb-2 mb-sm-0">Checkout.com</h6>
                                    <div className="d-flex flex-wrap gap-4">
                                        <img
                                            src="../../assets/img/icons/payments/visa-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="visa-card"
                                            data-app-light-img="icons/payments/visa-light.png"
                                            data-app-dark-img="icons/payments/visa-dark.png" />
                                        <img
                                            src="../../assets/img/icons/payments/master-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="master-card"
                                            data-app-light-img="icons/payments/master-light.png"
                                            data-app-dark-img="icons/payments/master-dark.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Payment provider modal  */}

                {/* Payment Methods modal */}
                <div className="modal fade" id="paymentMethods" tabindex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-simple modal-enable-otp modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body p-0">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                <div className="text-center mb-6">
                                    <h4 className="mb-2">Select payment methods</h4>
                                    <p>Supported payment methods</p>
                                </div>

                                <div className="d-flex justify-content-between align-items-center border-bottom py-4 mb-4">
                                    <div className="d-flex gap-4 align-items-center">
                                        <img
                                            src="../../assets/img/icons/payments/visa-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="visa-card"
                                            data-app-light-img="icons/payments/visa-light.png"
                                            data-app-dark-img="icons/payments/visa-dark.png" />

                                        <h6 className="m-0">Visa</h6>
                                    </div>
                                    <p className="m-0 d-none d-sm-block">Credit Card</p>
                                </div>
                                <div className="d-flex justify-content-sm-between align-items-center border-bottom pb-4 mb-4">
                                    <div className="d-flex gap-4 align-items-center">
                                        <img
                                            src="../../assets/img/icons/payments/ae-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="american-express-card"
                                            data-app-light-img="icons/payments/ae-light.png"
                                            data-app-dark-img="icons/payments/ae-dark.png" />

                                        <h6 className="m-0">American Express</h6>
                                    </div>
                                    <p className="m-0 d-none d-sm-block">Credit Card</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center border-bottom pb-4 mb-4">
                                    <div className="d-flex gap-4 align-items-center">
                                        <img
                                            src="../../assets/img/icons/payments/master-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="master-card"
                                            data-app-light-img="icons/payments/master-light.png"
                                            data-app-dark-img="icons/payments/master-dark.png" />

                                        <h6 className="m-0">Mastercard</h6>
                                    </div>
                                    <p className="m-0 d-none d-sm-block">Credit Card</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center border-bottom pb-4 mb-4">
                                    <div className="d-flex gap-4 align-items-center">
                                        <img
                                            src="../../assets/img/icons/payments/jcb-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="jcb-card"
                                            data-app-light-img="icons/payments/jcb-light.png"
                                            data-app-dark-img="icons/payments/jcb-dark.png" />
                                        <h6 className="m-0">JCB</h6>
                                    </div>
                                    <p className="m-0 d-none d-sm-block">Credit Card</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex gap-4 align-items-center">
                                        <img
                                            src="../../assets/img/icons/payments/dc-light.png"
                                            className="img-fluid w-px-50 h-px-30"
                                            alt="diners-club-card"
                                            data-app-light-img="icons/payments/dc-light.png"
                                            data-app-dark-img="icons/payments/dc-dark.png" />
                                        <h6 className="m-0">Diners Club</h6>
                                    </div>
                                    <p className="m-0 d-none d-sm-block">Credit Card</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}
